<template>
  <div class="_container">
    <el-card shadow="never" class="_card">
      <el-form :model="form" :rules="rules" ref="yearForm" :inline="true">
        <el-form-item label="Select Report" prop="year">
          <el-select
            style="width: 300px"
            v-model="form.selectReportId"
            multiple
            :multiple-limit="3"
            @change="handleClickReport"
          >
            <el-option
              v-for="item in selectReportData"
              :key="item.id"
              :label="`${item.reportYear}  ${item.reportQuarter}`"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span style="margin: 0 10px 0 20px">Currency</span>
          <el-select
            v-model="currency"
            @change="handleCurrencyChange"
            size="small"
            class="_selectCurrency"
          >
            <el-option
              v-for="item in currencyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <customize-button
            type="primary"
            @click="handleSearch"
            v-if="isShowSearchBtn"
          >
            Search
          </customize-button>
        </el-form-item>
        <el-form-item>
          <customize-button
            type="primary"
            v-if="isShowComparisonBtn"
            @click="handleClickComparisonViewBtn"
          >
            Comparison View
          </customize-button>
        </el-form-item>
      </el-form>
      <el-row :gutter="24" v-if="isShowSearchBtn">
        <el-col :span="8" class="col_row">
          <span>Data Source:</span>
          <span>{{ dataSource }}</span>
        </el-col>
        <el-col :span="8" class="col_row">
          <span>Account Type：</span>
          <span>{{ filterNameAccountType(accountType) }}</span>
        </el-col>
        <el-col :span="8" class="col_row">
          <span>Auditors'opinion：</span>
          <span>{{ filterNameAuditorsOpinion(auditorsOpinion) }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.isSelectedReportIds.length > 1">
        <el-col :span="6" class="col_margin">
          <span>Select Report</span>
        </el-col>
        <el-col :span="6" class="col_margin">
          <span>Data Source</span>
        </el-col>
        <el-col :span="6" class="col_margin">
          <span>Account Type</span>
        </el-col>
        <el-col :span="6" class="col_margin">
          <span>Auditors'opinion</span>
        </el-col>
      </el-row>
      <template v-if="this.isSelectedReportIds.length > 1">
        <el-row
          :gutter="24"
          v-for="(item, index) in this.selectedReportArr"
          :key="index"
        >
          <el-col :span="6" class="col_margin">
            <span>{{ `${item.reportYear}  ${item.reportQuarter}` }}</span>
          </el-col>
          <el-col :span="6" class="col_margin">
            <span>{{ item.attachmentId ? 'Linkredit' : 'CRMZ' }}</span>
          </el-col>
          <el-col :span="6" class="col_margin">
            <span>{{ filterNameAccountType(item.accountType) }}</span>
          </el-col>
          <el-col :span="6" class="col_margin">
            <span>{{ filterNameAuditorsOpinion(item.auditorsOpinion) }}</span>
          </el-col>
        </el-row>
      </template>
    </el-card>
    <el-card class="_card" shadow="never">
      <div class="actionBtn">
        <el-popover
          class="popover_class"
          placement="top-start"
          trigger="hover"
          content="Average of same Business Type in same Sales Country"
          v-if="isMultiple"
        >
          <el-checkbox
            slot="reference"
            v-model="isAverageData"
            @change="handleClickAverage"
          >
            Average Data
          </el-checkbox>
        </el-popover>

        <customize-button type="primary" @click="handleExportData">
          Download
        </customize-button>
      </div>
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="Income Statement" name="one">
          <financial-chart
            v-for="item in chartData"
            :key="item.field"
            :chartData="item"
            :field="item.field"
            :fieldName="item.fieldName"
          />
          <div
            v-for="item in financeIncomes && financeIncomes.length"
            :key="item"
          >
            <table-view
              ref="incomeTable"
              :showPage="false"
              :tableModel="tableIOModel(financeIncomes[item - 1])"
              :tableData="tableIOData(financeIncomes[item - 1])"
            >
              <template v-slot:key0="{ tableRow }">
                <a
                  style="font-weight: bold"
                  v-if="oneKeys.indexOf(tableRow.row.key0) !== -1"
                >
                  {{ tableRow.row.key0 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key0 }}
                </a>
              </template>
              <template v-slot:key3="{ tableRow }" v-if="colorId === 2">
                <a style="color: red" v-if="Number(tableRow.row.key3) < 0">
                  {{ tableRow.row.key3 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key3 }}
                </a>
              </template>
              <template v-slot:key4="{ tableRow }" v-if="colorId === 3">
                <a style="color: red" v-if="Number(tableRow.row.key4) < 0">
                  {{ tableRow.row.key4 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key4 }}
                </a>
              </template>
              <template v-slot:action="{ tableRow }">
                <a
                  v-if="existedKeys.indexOf(tableRow.row.key0) === -1"
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleChart(tableRow)"
                >
                  Chart
                </a>
                <a
                  v-else
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleReplace(tableRow.row)"
                >
                  Take Down
                </a>
                <a
                  href="javascript:;"
                  v-if="oneNoEdit.indexOf(tableRow.row.key0) === -1"
                  style="margin-right: 20px"
                  @click="_handleEdit(tableRow, item, activeTab)"
                >
                  Edit
                </a>
              </template>
            </table-view>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Balance Sheet" name="two">
          <financial-chart
            v-for="item in chartData"
            :key="item.field"
            :chartData="item"
            :field="item.field"
            :fieldName="item.fieldName"
          />
          <p>Balance Sheet</p>
          <div
            v-for="item in financeBalances && financeBalances.length"
            :key="item"
          >
            <table-view
              ref="incomeTable"
              :showPage="false"
              :tableModel="tableIOModel(financeBalances[item - 1])"
              :tableData="tableIOData(financeBalances[item - 1])"
            >
              <template v-slot:key0="{ tableRow }">
                <a
                  style="font-weight: bold"
                  v-if="twoKeys.indexOf(tableRow.row.key0) !== -1"
                >
                  {{ tableRow.row.key0 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key0 }}
                </a>
              </template>
              <template v-slot:key3="{ tableRow }" v-if="colorId === 2">
                <a style="color: red" v-if="Number(tableRow.row.key3) < 0">
                  {{ tableRow.row.key3 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key3 }}
                </a>
              </template>
              <template v-slot:key4="{ tableRow }" v-if="colorId === 3">
                <a style="color: red" v-if="Number(tableRow.row.key4) < 0">
                  {{ tableRow.row.key4 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key4 }}
                </a>
              </template>
              <template v-slot:action="{ tableRow }">
                <a
                  v-if="existedKeys.indexOf(tableRow.row.key0) === -1"
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleChart(tableRow)"
                >
                  Chart
                </a>
                <a
                  v-else
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleReplace(tableRow.row)"
                >
                  Take Down
                </a>
                <a
                  href="javascript:;"
                  v-if="twoNoEdit.indexOf(tableRow.row.key0) === -1"
                  style="margin-right: 20px"
                  @click="_handleEdit(tableRow, item, activeTab)"
                >
                  Edit
                </a>
              </template>
            </table-view>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Cash Flow" name="four">
          <financial-chart
            v-for="item in chartData"
            :key="item.field"
            :chartData="item"
            :field="item.field"
            :fieldName="item.fieldName"
          />
          <p>Cash Flow</p>

          <div v-for="item in cashflows && cashflows.length" :key="item">
            <table-view
              ref="incomeTable"
              :showPage="false"
              :tableModel="tableIOModel(cashflows[item - 1])"
              :tableData="tableIOData(cashflows[item - 1])"
            >
              <template v-slot:key0="{ tableRow }">
                <a
                  style="font-weight: bold"
                  v-if="threeKeys.indexOf(tableRow.row.key0) !== -1"
                >
                  {{ tableRow.row.key0 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key0 }}
                </a>
              </template>
              <template v-slot:key3="{ tableRow }" v-if="colorId === 2">
                <a style="color: red" v-if="Number(tableRow.row.key3) < 0">
                  {{ tableRow.row.key3 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key3 }}
                </a>
              </template>
              <template v-slot:key4="{ tableRow }" v-if="colorId === 3">
                <a style="color: red" v-if="Number(tableRow.row.key4) < 0">
                  {{ tableRow.row.key4 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key4 }}
                </a>
              </template>
              <template v-slot:action="{ tableRow }">
                <a
                  v-if="existedKeys.indexOf(tableRow.row.key0) === -1"
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleChart(tableRow)"
                >
                  Chart
                </a>
                <a
                  v-else
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleReplace(tableRow.row)"
                >
                  Take Down
                </a>
                <a
                  href="javascript:;"
                  v-if="threeNoEdit.indexOf(tableRow.row.key0) === -1"
                  style="margin-right: 20px"
                  @click="_handleEdit(tableRow, item, activeTab)"
                >
                  Edit
                </a>
              </template>
            </table-view>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Financial Ratios" name="three">
          <financial-chart
            v-for="item in chartData"
            :key="item.field"
            :chartData="item"
            :field="item.field"
            :fieldName="item.fieldName"
          />
          <p>Financial Ratios</p>
          <div
            v-for="item in financeRatios && financeRatios.length"
            :key="item"
          >
            <table-view
              ref="incomeTable"
              :showPage="false"
              :tableModel="tableIOModel(financeRatios[item - 1])"
              :tableData="tableIOData(financeRatios[item - 1])"
            >
              <template v-slot:key0="{ tableRow }">
                <a
                  style="font-weight: bold"
                  v-if="fourKeys.indexOf(tableRow.row.key0) !== -1"
                >
                  {{ tableRow.row.key0 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key0 }}
                </a>
              </template>
              <template v-slot:key3="{ tableRow }" v-if="colorId === 2">
                <a style="color: red" v-if="Number(tableRow.row.key3) < 0">
                  {{ tableRow.row.key3 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key3 }}
                </a>
              </template>
              <template v-slot:key4="{ tableRow }" v-if="colorId === 3">
                <a style="color: red" v-if="Number(tableRow.row.key4) < 0">
                  {{ tableRow.row.key4 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key4 }}
                </a>
              </template>
              <template v-slot:action="{ tableRow }">
                <div
                  v-if="
                    tableRow.row.key0 !== 'Is the balance sheet in balance?'
                  "
                >
                  <a
                    v-if="existedKeys.indexOf(tableRow.row.key0) === -1"
                    href="javascript:;"
                    style="
                      display: inline-block;
                      margin-right: 20px;
                      width: 70px;
                    "
                    @click="_handleChart(tableRow)"
                  >
                    Chart
                  </a>
                  <a
                    v-else
                    href="javascript:;"
                    style="
                      display: inline-block;
                      margin-right: 20px;
                      width: 70px;
                    "
                    @click="_handleReplace(tableRow.row)"
                  >
                    Take Down
                  </a>
                </div>
              </template>
            </table-view>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!--弹窗-->
    <el-dialog
      :close-on-click-modal="false"
      title="Edit"
      :visible.sync="showDialog"
      width="30%"
      @close="_handleEditClose"
    >
      <el-form>
        <el-form-item
          v-for="(item, index) in editDialogForm"
          :label="`year ${item.label}`"
          :key="index"
        >
          <el-input v-model="item.value"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="_handleEditCancel">Cancel</el-button>
        <el-button type="primary" @click="_handleConfirm">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Exchange Rate"
      :visible.sync="isShowExchangeRate"
      width="700px"
    >
      <el-form>
        <el-form-item label="Currency" prop="currency">
          <el-select
            v-model="modelForm.currency"
            style="width: 100%"
            filterable
            disabled
          >
            <el-option
              v-for="item in this.selectCurrencyList"
              :label="item.currencyName"
              :value="item.currency"
              :key="item.currency"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Exchange Date" v-if="form.currency !== 'USD'">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="modelForm.exchangeDate"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="Exchange Rate(USD)" v-if="form.currency !== 'USD'">
          <el-input
            :disabled="true"
            v-model="modelForm.exchangeRate"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowExchangeRate = false">Cancel</el-button>
        <el-button type="primary" @click="handleClickCalcRate">
          Confirm
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FinancialChart from './components/financial-chart'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash/lang'
import {
  getTheChart,
  getReportTableData,
  getMultipleData,
  downLoadSelectReport,
  editData,
} from './api'
import {
  getCurrencyList,
  getCurrenyRate,
} from 'views/customer-mangement/detail/financial-report/api'

export default {
  name: 'financial-analysis',
  components: {
    FinancialChart,
  },
  data() {
    const rules = {}
    return {
      activeTab: 'one',
      form: {
        year: `${dayjs().year()}`,
        selectReportId: [],
      },
      rules,
      // 图表数据
      cashflows: [],
      financeBalances: [],
      financeIncomes: [],
      financeRatios: [],
      chartData: [], // 三个图表的data
      tableModel: [], // 抽出table model, table data
      // tableIOModel: [],
      tableData: [],
      existedKeys: [],
      tableYears: [],
      showDialog: false,
      editForm: {},
      editRules: {},
      curObj: null,
      oneKeys: ['Revenues', 'EBITDA', 'Profit after Tax'],
      oneNoEdit: ['Gross Profit', 'EBITDA', 'Retained Profit'],
      twoKeys: [
        'Total Assets',
        'Fixed Assets',
        'Current Assets',
        'Current Liabilities',
        'Long-term Liabilities',
        'Total Liabilities',
        'Net Financial Debt',
        'Equity',
        'Tangible Net Worth',
      ],
      twoNoEdit: [
        'Total Assets',
        'Fixed Assets',
        'Current Assets',
        'Current Liabilities',
        'Long-term Liabilities',
        'Total Liabilities',
        'Net Financial Debt',
        'Tangible Net Worth',
      ],
      threeKeys: [
        'Cash Flow from Operations (CFO)',
        'Cash Flow from Investing Activities (CFI)',
        'Cash Flow from Financing (CFF)',
        'Change in Cash',
      ],
      threeNoEdit: ['Change in Cash'],
      blod: false,
      fourKeys: [
        'Net Cash provided (used) by Operating Activities',
        'Net Cash provided (used) by Investing Activities',
        'Net Cash provided (used) by Financing Activities',
        'Net Cash provided (used) by all above activities',
      ],
      currency: '',
      isShowExchangeRate: false,
      selectReportData: [],
      QList: [
        {
          id: 5,
          name: 'H1',
        },
        {
          id: 6,
          name: 'H2',
        },
        {
          id: 1,
          name: 'Q1',
        },
        {
          id: 2,
          name: 'Q2',
        },
        {
          id: 3,
          name: 'Q3',
        },
        {
          id: 4,
          name: 'Q4',
        },
      ],
      isShowComparisonBtn: false,
      isShowSearchBtn: true,
      isSelectedReportIds: [],
      currencyList: [],
      isAverageData: true,
      newArrDateAll: [],
      dataSource: '',
      colorId: '',
      accountType: '',
      auditorsOpinion: '',
      tableIOALLData: [],
      isMultiple: true,
      conversionRate: '1.0',
      selectCurrencyList: [],
      modelForm: { exchangeDate: '', currency: '', exchangeRate: '' },
      selectedReportArr: [],
      editDialogForm: [],
    }
  },
  async mounted() {
    this.fieldName = ''
    await this._getTableData()
    if (this.selectReportData.length) {
      await this.getAllData()
    }
    await this._getCurrencyList()
  },
  watch: {
    modelForm: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.currency && val.exchangeDate) {
          this._getCurrenyRate()
        }
      },
    },
  },
  methods: {
    // 处理数据
    tableIOData(data) {
      const arrDate = cloneDeep(data)
      const newArrDateAll = []
      for (let index = 1; index < arrDate.length; index++) {
        const s = Object.keys(arrDate[index])[0]
        const oneValue = arrDate[index][s]
        oneValue.unshift(s)
        const newArrDate = oneValue.map((value, index) => ({
          value: 'key' + index,
          label: value,
        }))
        newArrDate.map(item => {
          if (item.value !== 'key0') {
            if (item.label !== 'No' && item.label !== 'Yes') {
              item.label = this.$utils.formatAmount(item.label)
            }
          }
        })
        let obj = {}
        newArrDate.forEach(item => {
          obj[item.value] = item.label
        })
        newArrDateAll.push(obj)
      }
      return newArrDateAll
    },
    // 处理表头
    tableIOModel(data) {
      const arr = cloneDeep(data[0])
      const s = Object.keys(arr)[0]
      const oneValue = arr[s]
      oneValue.unshift(s)
      const newArr = oneValue.map((value, index) => ({
        prop: 'key' + index,
        label: value,
      }))
      newArr[0].slotName = newArr[0].prop
      newArr[0].width = '350px'
      if (this.form.selectReportId.length === 2 && this.colorId === 2) {
        if (newArr[3]) {
          newArr[3].slotName = newArr[3].prop
        }
      }
      if (this.form.selectReportId.length === 3 && this.colorId === 3) {
        if (newArr[4]) {
          newArr[4].slotName = newArr[4].prop
        }
      }
      newArr &&
        newArr.push({
          label: 'Action',
          slotName: 'action',
          width: '200px',
        })
      return newArr
    },
    async handleClickCalcRate() {
      const { currency, exchangeRate } = this.modelForm
      if (currency && exchangeRate) {
        this.conversionRate = exchangeRate
        await this.getAllData({ showCurrency: 2, currency: 3 })
        this.isShowExchangeRate = false
      } else {
        this.$message.warning('Please select')
      }
    },
    async _getCurrenyRate() {
      const { rate } = await getCurrenyRate(
        this.modelForm.exchangeDate,
        this.modelForm.currency,
      )
      this.modelForm.exchangeRate = rate
    },
    async _getCurrencyList() {
      try {
        this.selectCurrencyList = await getCurrencyList()
      } catch (err) {
        console.error(err)
      }
    },
    async handleClickAverage(boolean) {
      if (this.selectReportData.length) {
        this.isAverageData = boolean
        await this.getAllData()
      }
    },
    async getAllData(data = {}) {
      let params = {
        type:
          this.activeTab === 'one'
            ? 1
            : this.activeTab === 'two'
            ? 2
            : this.activeTab === 'three'
            ? 3
            : 4,
        exchangeRate: this.conversionRate,
        showCurrency: data?.showCurrency || 1,
        showAverage: this.isAverageData ? 1 : 2,
      }
      const { selectReportId } = this.form

      if (selectReportId.length > 1) {
        params.financeIds = [...selectReportId]
      } else {
        params.financeId = selectReportId[0]
      }

      if (data.currency) {
        params.currency = data.currency
      } else {
        params.currency = this.currency
      }

      const { analysisVO, chartsVO } = await getMultipleData(params)
      const _chartData = []
      const _keys = Object.keys(chartsVO)
      for (let i = 0; i < Object.keys(chartsVO).length; i++) {
        if (chartsVO[_keys[i]].chartData.length === 0) {
          chartsVO[_keys[i]].chartData.push({
            year: dayjs().year(),
            value: 0,
          })
        }
        _chartData.push(chartsVO[_keys[i]])
      }
      this.chartData = _chartData
      this.existedKeys = this.chartData.map(item => item.fieldName)
      const { cashflows, financeBalances, financeIncomes, financeRatios } =
        analysisVO
      // 赋值  tab===3
      this.cashflows = cashflows && cashflows.slice(0, cashflows.length - 1)
      this.cashflowsIds =
        cashflows && cashflows[cashflows.length - 1][0]['financeIds']
      // 赋值  tab===2
      this.financeBalances =
        financeBalances && financeBalances.slice(0, financeBalances.length - 1)
      this.financeBalancesIds =
        financeBalances &&
        financeBalances[financeBalances.length - 1][0]['financeIds']
      // 赋值  tab===1
      this.financeIncomes =
        financeIncomes && financeIncomes.slice(0, financeIncomes.length - 1)
      this.financeIncomesIds =
        financeIncomes &&
        financeIncomes[financeIncomes.length - 1][0]['financeIds']
      // 赋值  tab===4
      this.financeRatios =
        financeRatios && financeRatios.slice(0, financeRatios.length - 1)
      this.financeRatiosIds =
        financeRatios &&
        financeRatios[financeRatios.length - 1][0]['financeIds']
    },
    async handleClickComparisonViewBtn() {
      this.colorId = this.form.selectReportId.length
      if (!this.currency) {
        this.$message.warning('Please select Currency')
        return
      }
      await this.getAllData({ showCurrency: this.currency === 'USD' ? 1 : 2 })
    },
    async handleExportData() {
      const result = this.currencyList.filter(
        item => item.value === this.currency,
      )[0]
      const params = {
        type:
          this.activeTab === 'one'
            ? 1
            : this.activeTab === 'two'
            ? 2
            : this.activeTab === 'three'
            ? 3
            : 4,
        exchangeRate: this.conversionRate,
        showCurrency: result.label === 'USD' ? 1 : 2,
        currency: result.value,
      }
      if (this.isSelectedReportIds.length > 1) {
        params.financeIds = this.isSelectedReportIds
        params.showAverage = 2
      } else {
        params.financeId =
          this.form.selectReportId.join() || this.isSelectedReportIds.join()
        params.showAverage = this.isAverageData ? 1 : 2
      }
      await downLoadSelectReport(params)
      this.$message.success('success')
    },
    setCurrencyList(ids) {
      if (ids.length > 1) {
        // 处理多选
        const filterArr = []
        for (const id of ids) {
          const list = this.selectReportData.filter(item => item.id === id)
          if (list.length) {
            filterArr.push(list[0])
          }
        }
        const index = filterArr.findIndex(item => item.currency === 'USD')
        if (index !== -1) {
          this.currencyList = [
            {
              value: 'USD',
              label: 'USD',
              exchangeRate: 1,
            },
          ]
          return
        }

        const target = filterArr[0].currency
        const isEqual = filterArr.every(
          currentValue => currentValue.currency === target,
        )

        if (isEqual) {
          // select Exchange Date弹窗赋值本币币种
          this.modelForm.currency = target
          this.currencyList = [
            {
              value: 'USD',
              label: 'USD',
              exchangeRate: 1,
            },
            {
              value: target,
              label: target,
              exchangeRate: filterArr[0].exchangeRate,
            },
            {
              value: 3,
              label: 'Select Exchange Date',
            },
          ]
        } else {
          this.currencyList = [
            {
              value: 'USD',
              label: 'USD',
              exchangeRate: 1,
            },
          ]
        }
      } else if (ids.length === 1) {
        // 处理单选
        const result = this.selectReportData.filter(
          item => item.id === ids[0],
        )[0]
        if (result.currency === 'USD') {
          this.currencyList = [
            {
              value: 'USD',
              label: 'USD',
              exchangeRate: 1,
            },
          ]
          return
        }
        this.currencyList = [
          {
            value: 'USD',
            label: 'USD',
            exchangeRate: 1,
          },
          {
            value: result.currency,
            label: result.currency,
            exchangeRate: result.exchangeRate,
          },
          {
            value: 3,
            label: 'Select Exchange Date',
          },
        ]
        this.modelForm.currency = result.currency
      }
    },
    handleClickReport(isSelectedIds) {
      if (isSelectedIds.length === 0) {
        this.currency = ''
        this.currencyList = []
      }
      if (isSelectedIds.length > 1) {
        this.isShowComparisonBtn = true
        this.isShowSearchBtn = false
        this.isMultiple = false
        this.setCurrencyList(isSelectedIds)
      } else {
        this.isShowComparisonBtn = false
        this.isShowSearchBtn = true
        this.isMultiple = true
        this.setCurrencyList(isSelectedIds)
      }
      this.isSelectedReportIds = isSelectedIds
      const arr = []
      this.isSelectedReportIds.forEach(isSelectedId => {
        const list = this.selectReportData.filter(
          item => item.id === isSelectedId,
        )
        arr.push(list[0])
        this.selectedReportArr = arr
        if (list[0].attachmentId) {
          this.dataSource = 'Linkredit'
        } else {
          this.dataSource = 'CRMZ'
        }
        this.accountType = list[0].accountType
        this.auditorsOpinion = list[0].auditorsOpinion
      })
    },
    async _getTableData(params) {
      try {
        const { data } = await getReportTableData({
          ...params,
          companyId: this.$route.params.customerId,
        })
        this.selectReportData = data
        // 处理客户没有财报的情况
        if (this.selectReportData.length) {
          this.currency = 'USD'
          if (this.selectReportData[0].currency === 'USD') {
            this.currencyList = [
              {
                value: 'USD',
                label: 'USD',
                exchangeRate: 1,
              },
            ]
          } else {
            this.modelForm.currency = this.selectReportData[0].currency
            this.currencyList = [
              {
                value: 'USD',
                label: 'USD',
                exchangeRate: 1,
              },
              {
                value: this.selectReportData[0].currency,
                label: this.selectReportData[0].currency,
                exchangeRate: this.selectReportData[0].exchangeRate,
              },
              {
                value: 3,
                label: 'Select Exchange Date',
              },
            ]
          }
          if (this.selectReportData[0].attachmentId) {
            this.dataSource = 'Linkredit'
          } else {
            this.dataSource = 'CRMZ'
          }
          this.accountType = this.selectReportData[0].accountType
          this.auditorsOpinion = this.selectReportData[0].auditorsOpinion
          const selectReportIds = []
          selectReportIds.push(this.selectReportData[0].id)
          this.form.selectReportId = selectReportIds
          this.selectReportData.map(item => {
            if (item.reportQuarter === null) {
              item.reportQuarter = ''
            }
            this.QList.forEach(i => {
              if (item.reportQuarter === i.id) {
                item.reportQuarter = i.name
              }
            })
          })
        }
      } catch (err) {
        console.error(err)
      }
    },
    filterNameAccountType(status) {
      switch (status) {
        case 1:
          return 'Consolidated'
        case 2:
          return 'Stand alone'
      }
    },
    filterNameAuditorsOpinion(status) {
      switch (status) {
        case 1:
          return 'Unqualified'
        case 2:
          return 'With Remarks'
        case 3:
          return 'Qualified'
        case 4:
          return 'Non-audited'
      }
    },
    async handleCurrencyChange(currency) {
      if (currency !== 3) {
        const result = this.currencyList.filter(
          item => item.value === currency,
        )[0]
        this.conversionRate = result.exchangeRate
        // await this.getAllData({ showCurrency: 2, currency: result.label })
      }
      this.isShowExchangeRate = currency === 3
    },
    async handleTabChange() {
      if (this.selectReportData.length) {
        if (this.currency !== 3) {
          const result = this.currencyList.filter(
            item => item.value === this.currency,
          )[0]
          this.conversionRate = result.exchangeRate
          await this.getAllData({
            showCurrency: result.label === 'USD' ? 1 : 2,
            currency: result.label,
          })
        } else {
          await this.getAllData({
            showCurrency: 2,
            currency: 3,
          })
        }
      }
    },
    async _handleChart(obj) {
      try {
        let type = ''
        let editDataIds = []
        if (this.activeTab === 'one') {
          type = 1
          editDataIds = this.financeIncomesIds
        } else if (this.activeTab === 'two') {
          editDataIds = this.financeBalancesIds
          type = 2
        } else if (this.activeTab === 'three') {
          editDataIds = this.financeRatiosIds
          type = 3
        } else {
          editDataIds = this.cashflowsIds
          type = 4
        }
        const financeIds = this._getEditIndex(editDataIds).map(item => item.id)
        const result = this.currencyList.filter(
          item => item.value === this.currency,
        )[0]
        const params = {
          financeIds: financeIds,
          type: type,
          fieldName: obj.row.key0,
          showCurrency: result.label === 'USD' ? 1 : 2,
          currency: result.value,
          exchangeRate: result.exchangeRate,
        }
        const res = await getTheChart(params)
        if (this.chartData.length < 3) {
          this.chartData.push(res)
          this.chartData = [].concat(...this.chartData)
          this.existedKeys = this.chartData.map(obj => obj.fieldName)
        } else {
          this.chartData.splice(this.chartData.length - 1, 1, res)
          this.existedKeys = this.chartData.map(obj => obj.fieldName)
        }
      } catch (err) {
        console.error(err)
      }
    },
    _handleReplace(obj) {
      const index = this.chartData.findIndex(
        item => item.fieldName === obj.key0,
      )
      if (index !== -1) {
        this.chartData.splice(index, 1)
        this.existedKeys = this.chartData.map(obj => obj.fieldName)
      }
    },
    // 查找可以修改的索引(主要是为了排除平均值，平均值不可以修改)
    _getEditIndex(data) {
      const indexArr = []
      data.forEach((item, index) => {
        if (item !== null) {
          indexArr.push({
            id: item,
            index,
          })
        }
      })
      return indexArr
    },
    // action - edit
    _handleEdit(row, tableIndex, activeTab) {
      var editDataIds = []
      var editData = []
      if (activeTab === 'one') {
        editDataIds = this.financeIncomesIds
        editData = this.financeIncomes
      } else if (activeTab === 'two') {
        editDataIds = this.financeBalancesIds
        editData = this.financeBalances
      } else if (activeTab === 'three') {
        editDataIds = this.financeRatiosIds
        editData = this.financeRatios
      } else {
        editDataIds = this.cashflowsIds
        editData = this.cashflows
      }
      const indexArr = this._getEditIndex(editDataIds)
      // 点击的 table 索引
      const clickTableIndex = tableIndex - 1 //数组的第几项
      // 点击的 table item 索引
      const clickTableItemIndex = row.$index + 1 //行数
      // 是否显示平均值
      const yearObj = editData[clickTableIndex][0] //第一行
      const yearKey = Object.keys(yearObj)[0] //属性
      const valueObj = editData[clickTableIndex][clickTableItemIndex]
      const valueKey = Object.keys(valueObj)[0] //属性
      // 初始年份
      const originalYearList = yearObj[yearKey] //年份
      this.fieldName = valueKey
      // 初始年份的值
      const originalYearValue = valueObj[valueKey]
      for (let index = 0; index < this.editDialogForm.length; index++) {
        this.editDialogForm[index] = {}
      }
      indexArr.forEach(item => {
        const { index } = item
        const obj = {
          value: originalYearValue[index],
          label: originalYearList[index],
        }
        this.editDialogForm.push(obj)
      })
      this.showDialog = true
      //editDialogForm
      // 处理平均值
      // if (showAverage) {
      //   // 有平均值数据处理
      //   for (let i = 0; i < originalYearList.length; i++) {
      //     if (i % 2 === 0) {
      //       formList.push({
      //         title: originalYearList[i],
      //         value: originalYearValue[i],
      //         valueTitle: valueKey,
      //       })
      //     }
      //   }
      // } else {
      //   // 没有平均值数据处理
      //   originalYearList.map((item, index) => {
      //     formList.push({
      //       title: originalYearList[index],
      //       value: originalYearValue[index],
      //       valueTitle: valueKey,
      //     })
      //   })
      // }

      // 回显number
      // const objKeys = Object.keys(obj)
      // this.editForm = { ...this.editForm }
      // Object.keys(this.editForm).forEach(key => {
      //   if (objKeys.indexOf(key) !== -1) {
      //     this.editForm[key] = obj[key]
      //   }
      // })

      // this.curObj = obj
    },
    // confirm
    async _handleConfirm() {
      for (let index = 0; index < this.editDialogForm.length; index++) {
        const element = this.editDialogForm[index]
        if (element.value === '') {
          this.$message.warning('Content cannot be empty')
          break
        }
      }
      let type = ''
      let editDataIds = []
      if (this.activeTab === 'one') {
        type = 1
        editDataIds = this.financeIncomesIds
      } else if (this.activeTab === 'two') {
        editDataIds = this.financeBalancesIds
        type = 2
      } else if (this.activeTab === 'three') {
        editDataIds = this.financeRatiosIds
        type = 3
      } else {
        editDataIds = this.cashflowsIds
        type = 4
      }
      const financeIds = this._getEditIndex(editDataIds).map(item => item.id)
      const values = this.editDialogForm.map(item => (item = item.value))
      const result = this.currencyList.filter(
        item => item.value === this.currency,
      )[0]
      await editData({
        financeIds,
        values,
        type,
        fieldName: this.fieldName,
        exchangeRate: result.exchangeRate,
        showCurrency: result.label === 'USD' ? 1 : 2,
        currency: result.label,
      })
      this.showDialog = false
      this.editDialogForm = []
      await this.getAllData()
    },
    handleSearch() {
      if (!this.form.selectReportId.length) {
        this.$message.warning('Please select Report')
        return
      }
      if (!this.currency) {
        this.$message.warning('Please select Currency')
        return
      }
      if (this.currency === 'USD') {
        this.getAllData()
      } else {
        this.getAllData({ showCurrency: 2 })
      }
    },
    _handleEditCancel() {
      this.showDialog = false
      this.editDialogForm = []
    },
    _handleEditClose() {
      this.editDialogForm = []
    },
  },
}
</script>

<style scoped lang="scss">
._container {
  min-width: 100%;
  height: 100%;
  ._card {
    margin-bottom: 20px;
  }
}
.actionBtn {
  text-align: end;
  position: relative;
}
.popover_class {
  margin-right: 20px;
}
._selectCurrency {
  margin: 0 58px 0 0;
}
.col_margin {
  margin-bottom: 10px;
  color: #606266;
  font-size: 14px;
}
.col_row {
  color: #606266;
  font-size: 14px;
}
</style>
